module.exports = __webpack_public_path__ + "static/media/githubLogo.e45ebd52.png";